// Helper for tracking an icon click (ic) in the Knit navbar.
// Used for the shopping bag.
const getICQueryValue = () => {
  const searchMatch = window.location.search.match(/(\?|&)ic=(.+)(&|$)/);

  return searchMatch ? searchMatch[2] : null;
};

export default getICQueryValue;
